import { render, staticRenderFns } from "./UserPrefs.vue?vue&type=template&id=236941ed&scoped=true&"
import script from "./UserPrefs.vue?vue&type=script&lang=js&"
export * from "./UserPrefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236941ed",
  null
  
)

export default component.exports